import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import cofre from './images/cofretiny.png';
import auracofre from './images/auracofre.png';
import miniCofre from './images/miniOverbox.png';
import GeneralPopUp from './components/generalPopUp';
import OverboxInfoVideoModal from './components/OverboxInfoVideoModal';
import OverboxOddsModal from './components/OverboxOddsModal';
import biruxComodin112 from './images/biruxComodin112.png';
import biruxBronce112 from './images/biruxBronce112.png';
import corazon64 from './images/corazon64.png';
import tiendaImg from './images/tienda112.png';
import misionesImg from './images/misiones112.png';
import { checkAuthError } from '../utils/sessionUtils';
import { useTutorial } from './components/Tutorial';

// Claves para sessionStorage
const POPUP_KEY = 'overbox_popup_open';
const POPUP_DATA_KEY = 'overbox_popup_data';

// Brillitos de la Mini Overbox: [left %, top %, retraso en s] sobre el cofre.
const BRILLOS = [[8, 18, 0], [86, 12, 0.5], [18, 78, 1.1], [80, 70, 0.3], [50, 0, 0.8], [96, 42, 1.4], [2, 48, 0.6], [62, 90, 1.7]];
const SWIPE_PX = 50; // lo que hay que arrastrar para pasar de cofre

const Overbox = ({ overBox, miniOverbox, dailyWebOverbox, handleAuth, hasTwitch }) => {
    const [isOpening, setIsOpening] = useState(false);
    // Carrusel: 0 = Overbox (siempre la primera), 1 = Mini Overbox.
    const [slide, setSlide] = useState(0);
    const [dragX, setDragX] = useState(0);
    const dragStartRef = React.useRef(null);
    const mini = slide === 1;
    const [showInfoVideo, setShowInfoVideo] = useState(false);
    const [showGetMore, setShowGetMore] = useState(false);
    const [showOdds, setShowOdds] = useState(false);
    const navigate = useNavigate();
    // Overbox del tutorial: van aparte de las normales y con premio fijo (apps/tutorial.js).
    const tutorial = useTutorial();
    const regaloRef = React.useRef(false); // su premio es el popup que se está viendo
    const avisarRef = React.useRef(null);
    avisarRef.current = tutorial && tutorial.avisar;

    // Leer estado inicial desde sessionStorage
    const [showPopUp, setShowPopUp] = useState(() => {
        return sessionStorage.getItem(POPUP_KEY) === 'true';
    });

    // Guardar los datos RAW (no JSX) para poder reconstruir el popup
    const [rewardData, setRewardData] = useState(() => {
        const stored = sessionStorage.getItem(POPUP_DATA_KEY);
        return stored ? JSON.parse(stored) : null;
    });

    useEffect(() => {
        return () => {
            sessionStorage.removeItem(POPUP_KEY);
            sessionStorage.removeItem(POPUP_DATA_KEY);
            // Si se va con el premio del tutorial abierto, el tutorial sigue igual que al cerrarlo.
            if (regaloRef.current && avisarRef.current) avisarRef.current('caja');
        };
    }, []);

    // Función para construir el popup content desde datos raw
    const buildPopupContent = (data) => {
        let imageSrc = biruxComodin112;
        let displayName = '';

        if (data.type === 'biruxComodin') {
            imageSrc = biruxComodin112;
            displayName = 'Birux Comodin';
        } else if (data.type === 'birux') {
            imageSrc = biruxBronce112;
            displayName = 'Birux';
        } else if (data.type === 'vidas') {
            imageSrc = corazon64;
            displayName = data.amount === 1 ? 'Combate de la Arena' : 'Combates de la Arena';
        } else if (data.type === 'reward') {
            displayName = data.rewardName || 'Recompensa';
            if (data.rewardImage) {
                imageSrc = `/images/rewards/${data.rewardImage}`;
            }
        }

        const rarityClass = `overboxRarity-${data.rarity}`;

        return {
            title: data.mini ? '¡Mini Overbox Abierta!' : '¡Overbox Abierta!',
            description: (
                <div className='overboxRewardContent'>
                    <div className={`overboxRewardImage ${rarityClass}-glow`}>
                        <img src={imageSrc} alt={displayName} onError={(e) => { e.target.src = biruxComodin112; }} />
                    </div>
                    <div className='overboxRewardDetails'>
                        <h3>{displayName}</h3>
                        {data.type !== 'reward' && (
                            <p className='overboxRewardAmount'>x{data.amount}</p>
                        )}
                        <p className='overboxRewardRarity'>Rareza: <strong>{data.rarity}</strong></p>
                    </div>
                </div>
            )
        };
    };

    // Helper para actualizar tanto el estado como sessionStorage
    const updateShowPopUp = (value) => {
        setShowPopUp(value);
        if (value) {
            sessionStorage.setItem(POPUP_KEY, 'true');
        } else {
            sessionStorage.removeItem(POPUP_KEY);
            sessionStorage.removeItem(POPUP_DATA_KEY);
        }
    };

    const handleOpenDailyOverbox = async () => {
        if (isOpening || dailyWebOverbox) return;

        setIsOpening(true);
        try {
            const response = await fetch('/api/openDailyWebOverbox', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (data.success) {
                const rawData = {
                    type: data.type,
                    amount: data.amount,
                    rarity: data.rarity,
                    rewardName: data.rewardName,
                    rewardImage: data.rewardImage
                };

                sessionStorage.setItem(POPUP_DATA_KEY, JSON.stringify(rawData));
                setRewardData(rawData);
                await handleAuth(false);
                updateShowPopUp(true);
            } else {
                console.error('Failed to open daily overbox:', data.error);
                if (data.error === 'already_claimed') {
                    await handleAuth(false);
                } else if (checkAuthError(data)) {
                    return;
                } else {
                    alert('No se pudo abrir la Overbox diaria. Por favor, intenta de nuevo.');
                }
            }
        } catch (error) {
            console.error('Network error:', error);
            alert('Error de red. Por favor, intenta de nuevo.');
        } finally {
            setIsOpening(false);
        }
    };

    const handleOpenTutorial = async () => {
        if (isOpening) return;

        setIsOpening(true);
        try {
            const response = await fetch('/api/tutorial', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ accion: 'abrir' })
            });

            const data = await response.json();

            if (data.success && data.type) {
                tutorial.avisar('cajaAbierta');
                const rawData = {
                    type: data.type,
                    amount: data.amount,
                    rarity: data.rarity,
                    rewardName: data.rewardName,
                    rewardImage: data.rewardImage
                };

                sessionStorage.setItem(POPUP_DATA_KEY, JSON.stringify(rawData));
                setRewardData(rawData);
                regaloRef.current = true;
                await handleAuth(false);
                updateShowPopUp(true);
            } else if (data.success || data.error === 'no_toca') {
                // Sin premio (recompensa borrada) o ya abierta (doble click, otra pestaña): el tutorial sigue.
                tutorial.avisar('caja');
            } else if (checkAuthError(data)) {
                return;
            } else {
                alert('No se pudo abrir la Overbox. Por favor, intenta de nuevo.');
            }
        } catch (error) {
            console.error('Network error:', error);
            alert('Error de red. Por favor, intenta de nuevo.');
        } finally {
            setIsOpening(false);
        }
    };

    const handleOpenOverbox = async (mini) => {
        if (isOpening || (mini ? miniOverbox : overBox) <= 0) return;

        setIsOpening(true);
        try {
            const response = await fetch(mini ? '/api/openMiniOverbox' : '/api/openOverbox', {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            const data = await response.json();

            if (data.success) {
                console.log('[Overbox] Opening, current count:', overBox);
                console.log('[Overbox] Response received:', data);

                // 1. Guardar datos de recompensa en sessionStorage
                const rawData = {
                    type: data.type,
                    amount: data.amount,
                    rarity: data.rarity,
                    rewardName: data.rewardName,
                    rewardImage: data.rewardImage,
                    mini: mini
                };

                sessionStorage.setItem(POPUP_DATA_KEY, JSON.stringify(rawData));

                // 2. Actualizar estado local de reward
                setRewardData(rawData);

                // 3. Llamar handleAuth para actualizar recursos desde BD
                console.log('[Overbox] Calling handleAuth...');
                await handleAuth(false);

                // 4. Mostrar popup DESPUÉS de actualizar recursos
                updateShowPopUp(true);

                console.log('[Overbox] handleAuth completed, showing popup');
            } else if (checkAuthError(data)) {
                return;
            } else {
                // Handle errors
                console.error('Failed to open overbox:', data.error);
                alert('No se pudo abrir la Overbox. Por favor, intenta de nuevo.');
            }
        } catch (error) {
            console.error('Network error:', error);
            alert('Error de red. Por favor, intenta de nuevo.');
        } finally {
            setIsOpening(false);
        }
    };

    // Arrastrar el cofre a la izquierda enseña la Mini Overbox; a la derecha vuelve.
    const onDragStart = (e) => {
        dragStartRef.current = e.clientX;
        e.currentTarget.setPointerCapture(e.pointerId);
    };
    const onDragMove = (e) => {
        if (dragStartRef.current === null) return;
        const dx = e.clientX - dragStartRef.current;
        setDragX(mini ? Math.max(dx, 0) : Math.min(dx, 0)); // no se pasa de los extremos
    };
    const onDragEnd = () => {
        if (dragX < -SWIPE_PX) setSlide(1);
        if (dragX > SWIPE_PX) setSlide(0);
        dragStartRef.current = null;
        setDragX(0);
    };

    return (
        <div id="" className="core heroes">
            {showInfoVideo && (
                <OverboxInfoVideoModal onClose={() => setShowInfoVideo(false)} />
            )}
            {showOdds && (
                <OverboxOddsModal mini={mini} onClose={() => setShowOdds(false)} />
            )}
            {showGetMore && (
                <div className='overboxGetMoreOverlay' onClick={() => setShowGetMore(false)}>
                <div className='PopUp heroes overboxGetMorePopUp' onClick={(e) => e.stopPropagation()}>
                    <span className='PopUpClose' onClick={() => setShowGetMore(false)}>X</span>
                    <div className='PopUpTitle'><h3>¿Cómo conseguir más Overbox?</h3></div>
                    <div className='flex heroes unselectable overboxGetMoreOptions'>
                        <div
                            className='btnForallia'
                            onClick={() => { setShowGetMore(false); navigate('/myAccount/shop?search=overbox'); }}
                        >
                            <div className='overboxGetMoreBtnInner'><img src={tiendaImg} alt="Tienda" /><span>Tienda</span></div>
                        </div>
                        <div
                            className='btnForallia'
                            onClick={() => { setShowGetMore(false); navigate('/myAccount/missions'); }}
                        >
                            <div className='overboxGetMoreBtnInner'><img src={misionesImg} alt="Misiones" /><span>Misiones</span></div>
                        </div>
                    </div>
                    <div className='overboxMoreMethods'>
                        <div className='overboxMoreMethodsTitle'>Más métodos</div>
                        <div className='overboxMoreMethodsList'>
                            {hasTwitch && (
                                <>
                                    <div className='overboxMethodItem'><span className='emote'>🎁</span><span>En el directo te doy Overbox con <strong>!overbox</strong></span></div>
                                    <div className='overboxMethodItem'><span className='emote'>🎲</span><span>Gana Overbox acertando predicciones con <strong>!bet</strong></span></div>
                                    <div className='overboxMethodItem'><span className='emote'>📅</span><span>Tu caja diaria gratis con <strong>!regalodiario</strong></span></div>
                                </>
                            )}
                            <div className='overboxMethodItem'><span className='emote'>🎟️</span><span>Códigos en el chat (ej. <strong>!GEL</strong>) → birux comodín gratis</span></div>
                            <div className='overboxMethodItem'><span className='emote'>🏆</span><span>Overbox en torneos y eventos en directo</span></div>
                        </div>
                    </div>
                </div>
                </div>
            )}
            {showPopUp && rewardData && (
                <GeneralPopUp
                    popUpData={buildPopupContent(rewardData)}
                    onClose={() => {
                        updateShowPopUp(false);
                        setRewardData(null);
                        if (regaloRef.current) {
                            regaloRef.current = false;
                            if (tutorial) tutorial.avisar('caja');
                        }
                    }}
                    isShop={false}
                />
            )}
            <div
                className='overboxCarousel unselectable'
                onPointerDown={onDragStart}
                onPointerMove={onDragMove}
                onPointerUp={onDragEnd}
                onPointerCancel={onDragEnd}
            >
                <div
                    className={'overboxCarouselTrack' + (slide === 0 && dragStartRef.current === null ? ' overboxHint' : '')}
                    style={{
                        transform: `translateX(calc(${-slide * 100}% + ${dragX}px))`,
                        transition: dragStartRef.current === null ? undefined : 'none'
                    }}
                >
                    <div className='overboxSlide'>
                        <div className='flex marginTop'><h2>Tienes {overBox} Overbox</h2></div>
                        <div className='flex overBoxWrap'>
                            <img className='overBox' src={cofre} alt="Overbox" draggable={false}></img>
                            <img className='overaura' src={auracofre} alt="Aura" draggable={false}></img>
                        </div>
                    </div>
                    <div className='overboxSlide'>
                        <div className='flex marginTop'><h2>Tienes {miniOverbox} Mini Overbox</h2></div>
                        <div className='flex overBoxWrap'>
                            <div className='miniOverboxGlow'>
                                <img className='overBox miniOverBox' src={miniCofre} alt="Mini Overbox" draggable={false}></img>
                                {BRILLOS.map(([left, top, delay]) => (
                                    <span
                                        key={`${left}-${top}`}
                                        className='miniBrillo'
                                        aria-hidden='true'
                                        style={{ left: left + '%', top: top + '%', animationDelay: delay + 's' }}
                                    >✦</span>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='overboxDots'>
                {['Overbox', 'Mini Overbox'].map((name, i) => (
                    <span
                        key={name}
                        role='button'
                        aria-label={name}
                        className={i === slide ? 'active' : ''}
                        onClick={() => setSlide(i)}
                    />
                ))}
            </div>
            <div className='flex heroes unselectable'>
                {tutorial && tutorial.caja ? (
                    <div
                        className={`btnForallia tutorialAbrir ${isOpening ? 'disabled' : ''}`}
                        onClick={handleOpenTutorial}
                    >
                        {isOpening ? 'Abriendo...' : 'Abrir regalo'}
                    </div>
                ) : null}
                {mini ? (miniOverbox > 0 ? (
                    <div
                        className={`btnForallia ${isOpening ? 'disabled' : ''}`}
                        onClick={() => handleOpenOverbox(true)}
                    >
                        {isOpening ? 'Abriendo...' : 'Abrir'}
                    </div>
                ) : null) : !dailyWebOverbox ? (
                    <div
                        className={`btnForallia villano ${isOpening ? 'disabled' : ''}`}
                        onClick={handleOpenDailyOverbox}
                    >
                        {isOpening ? 'Abriendo...' : 'Gratis diaria'}
                    </div>
                ) : overBox > 0 ? (
                    <div
                        className={`btnForallia ${isOpening ? 'disabled' : ''}`}
                        onClick={() => handleOpenOverbox(false)}
                    >
                        {isOpening ? 'Abriendo...' : 'Abrir'}
                    </div>
                ) : null}
                {/* La Mini Overbox de momento no se consigue por ninguna de estas vías. */}
                {!mini && (
                    <>
                        <div className='btnForallia heroe' onClick={() => setShowGetMore(true)}>
                            Conseguir Más
                        </div>
                        <div className='btnForallia' onClick={() => setShowInfoVideo(true)}>
                            ¿Qué es?
                        </div>
                    </>
                )}
                {/* Siempre visible, se tenga o no Overbox: hay que poder consultar las
                    probabilidades antes de abrir ninguna. */}
                <div className='btnForallia' onClick={() => setShowOdds(true)}>
                    Probabilidades
                </div>
            </div>
        </div>
    );
}

export default Overbox;
